/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('UploadRequest', [
        '$http',
        '$resource',
        'apiAddressFilter',
        'relativeUrlRootFilter',
        'UploadRequestInterceptor',
        function (
            $http,
            $resource,
            apiAddressFilter,
            relativeUrlRootFilter,
            UploadRequestInterceptor
        ) {
            var resource = $resource('/sync_and_share_nodes/upload_requests', {}, {
                // Private API
                query: {
                    method: 'GET',
                    isArray: true,
                    interceptor: UploadRequestInterceptor,
                    cancellable: true
                },
                create: {
                    method: 'POST',
                    url: apiAddressFilter('/sync_and_share_nodes/:node_uuid/upload_requests'),
                    params: {
                        node_uuid: '@node.uuid',
                    },
                    isArray: false,
                    transformRequest: _transformUploadRequest
                },
                update: {
                    method: 'PUT',
                    url: apiAddressFilter('/sync_and_share_nodes/:node_uuid/upload_requests/:request_uuid'),
                    params: {
                        node_uuid: '@node.uuid',
                        request_uuid: '@uuid'
                    },
                    isArray: false,
                    transformRequest: _transformUploadRequest
                },
                delete: {
                    method: 'DELETE',
                    url: apiAddressFilter('/sync_and_share_nodes/:node_uuid/upload_requests/:request_uuid'),
                    params: {
                        node_uuid: '@node.uuid',
                        request_uuid: '@uuid'
                    },
                    isArray: false
                },
                // Public API
                get: {
                    method: 'GET',
                    url: relativeUrlRootFilter('/public/upload_requests/:request_uuid'),
                    params: {
                        request_uuid: '@uuid'
                    },
                    interceptor: UploadRequestInterceptor,
                    ignoreApiErrors: true,
                    isArray: false
                }
            });

            function _transformUploadRequest(uploadRequest) {
                return angular.toJson({
                    access_restriction: uploadRequest.access_restriction,
                    max_file_count: uploadRequest.max_file_count,
                    max_file_size: uploadRequest.max_file_size,
                    allowed_file_extensions: uploadRequest.allowed_file_extensions,
                    locale: uploadRequest.locale,
                    expiration_date: uploadRequest.expiration_date
                });
            }

            resource.prototype.createSession = function () {
                return $http.post(relativeUrlRootFilter('/public/upload_requests/' + this.uuid + '/sessions'))
                    .then(function (response) {
                        return response.data.uuid;
                    });
            };

            resource.prototype.submitSession = function (
                sessionUUID,
                firstName,
                lastName,
                email
            ) {
                return $http.put(relativeUrlRootFilter('/public/upload_requests/' + this.uuid + '/sessions/' + sessionUUID), {
                    first_name: firstName,
                    last_name: lastName,
                    email: email,
                    completed: true
                });
            };

            resource.prototype.getUploadFileUrl = function (sessionUUID) {
                return relativeUrlRootFilter('/public/upload_requests/' + this.uuid + '/sessions/' + sessionUUID + '/file');
            };

            return resource;
        }]);
